import React from 'react'
import "./Home.css"
import LaptopChromebookIcon from '@material-ui/icons/LaptopChromebook';
import hm from "./asDeveloperHome.png"

function Home() {
    return (
        <div className="home">
            <div class="home_left">
                <h1><span id="heading">Web</span> Developer   <LaptopChromebookIcon fontSize="x-large" /></h1>
                <div className="left_text">
                    <h1>Hello</h1>
                    <marquee><h2><span id="head2">And Welcome !</span></h2></marquee>
                    <p id="description">I am <span id="name">Anirudh Sharma</span></p>
                    <p id="para2"> I am a <strong>Junior full-stack Developer</strong> passionate about web development !</p>
                </div>
            </div>
            <div className="home_right">
                <img className="logo" src={hm}></img>
            </div>
        </div>
    )
}

export default Home
